export default __webpack_public_path__ + "06d0a8a9765adcea98087831387e1073.svg";